import axios from "axios";
import router from '@/router';
import store from "@/store";

let isRefreshing = false;

export const expiredTokenHandler = async (response) => {

  // if (isRefreshing) return Promise.reject(response)
  //   // return
  

  // try {
  //   isRefreshing = true;

  //   const apiPreUrl = window.location.protocol + '//' + window.location.hostname + ':8008';
  //   const result = await axios.post(`${apiPreUrl}/api/auth/token`, {}, { withCredentials: true });

  //   const newAccessToken = result.data.access_token;
  //   sessionStorage.setItem("AccessToken", newAccessToken);
  //   // response.config.headers.Authorization = `Bearer ${result.data.access_token}`;
  //   response.config.headers = {
  //     ...response.config.headers,
  //     Authorization: `Bearer ${newAccessToken}`,
  //   };

  //   return axios(response.config);
  // } catch (error) {

 
  //   sessionStorage.removeItem("AccessToken");
  //   store.commit('user/setAccessToken', null);
  //   store.commit('user/SET_LOGIN_STATUS', false);

  //   window.alert('세션이 만료되었습니다. 다시 로그인해주세요.');
  //   // window.alert('세션이 만료되었습니다. 다시 로그인해주세요.\n' + (error?.message || JSON.stringify(error)));
  //   console.error('Token refresh failed:', error?.message || JSON.stringify(error));

  //   if (router.currentRoute.path !== '/') {
  //     // router.replace({ path: '/' });
  //     // console.log("router.currentRoute.value.fullPath => ", router.currentRoute)
  //     router.replace({ path: '/', query: { redirect: router.currentRoute.fullPath } });
  //   }
  //   // return Promise.reject(error);
  // } finally {
  //   isRefreshing = false;
  // }

  const apiPreUrl = window.location.protocol + '//' + window.location.hostname + ':8008';
  const result = await axios.post(`${apiPreUrl}/api/auth/token`, {}, { withCredentials: true });
  // console.log("result => ", result)
  sessionStorage.setItem("AccessToken", result.data.access_token);
  response.config.headers.Authorization = `Bearer ${result.data.access_token}`;

  return axios(response.config);
  










  // 예전 버전
  // try {
  //   const result = await axios.post(`${apiPreUrl}/api/auth/token`, {}, { withCredentials: true });
  //   sessionStorage.setItem("AccessToken", result.data.access_token);
  //   response.config.headers.Authorization = `Bearer ${result.data.access_token}`;

  //   //location.reload();
  //   return axios(response.config);
  // } catch (error) {
  //   sessionStorage.removeItem("AccessToken"); 
  //   location.href = '/'; 
  //   return Promise.reject(error);
  // }
}